import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IAdminOrgOption } from '@interfaces/index';

// The library owns this contract; the application binds it to whichever
// service actually calls HTTP (AdminOrganisationsService), so no HTTP
// crosses into ui-components. Signature mirrors
// AdminOrganisationsService.getOrgOptions exactly, so the app service
// implements it without an adapter layer.
export interface OrgOptionLookup {
  getOrgOptions(
    exclude_org_id?: number,
    search?: string,
    active_only?: boolean
  ): Observable<IAdminOrgOption[]>;
}

export const ORG_OPTION_LOOKUP = new InjectionToken<OrgOptionLookup>('ORG_OPTION_LOOKUP');
